import { render, staticRenderFns } from "./MyGifts.vue?vue&type=template&id=63ec4422&"
import script from "./MyGifts.js?vue&type=script&lang=js&"
export * from "./MyGifts.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports